import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import urlJoin from 'url-join';
import { v4 as uuidv4 } from 'uuid';
import { OktaWrapperService } from '@mysrc/services/framework';
import { ICurrentUser, IUserSettings, IUserSettingsTab } from '../models';
import { BaseHttpService } from './base-http.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseHttpService {
  private settingsObject?: IUserSettings;
  private currentSettings: { [key: string]: any; } = {};
  private lastSavedSettings: { [key: string]: any; } = {};
  private attempts: number = 0;

  private _settingsTabs: IUserSettingsTab[] = [];

  private _currentUser$: ReplaySubject<ICurrentUser> = new ReplaySubject<ICurrentUser>(1);

  private settingsEndpoint;
  private currentUserEndpoint;

  constructor(http: HttpClient, @Inject('CONFIG_SETTINGS') config: any, private oktaWrapper: OktaWrapperService) {
    super(http);
    const configGeneral = config['general'];
    this.baseUrl = configGeneral['adminApiUrl'];
    this.apiKey = configGeneral['apiKey'];

    const configUser = config['userSettings'];
    this.settingsEndpoint = configUser['settingsEndpoint'];
    this.currentUserEndpoint = configUser['currentUserEndpoint'];

    this.oktaWrapper.authenticationChanged.subscribe((isAuth: boolean) => {
      if (isAuth) {
        this.load();
      }
    });

    if (this.oktaWrapper.isAuthenticated()) {
      this.load();
    }

    //this.auth.tokenManager.on('added', (key: any) => {
    //  if (key == 'accessToken') {
    //    this.load();
    //  };

    //})

    //// If we are authenticated load, otherwise we will wait for the token to be added.
    //this.auth.isAuthenticated().then((isAuth: boolean) => {
    //  if (isAuth) { this.load(); }
    //});

  }

  load(): void {
    const token = this.getToken();
    if (token != undefined) {
      //this.loadSettings(token);
      //this.loadUser(token);
    }
  }

  private loadSettings(token: string) {

    // Retrieve from service

    const url = urlJoin(this.baseUrl, this.settingsEndpoint)
    this.getItem<IUserSettings>(url, this.getHttpBearerHeaders(token))
      .subscribe((prefs: any) => {
        if (prefs != null) {
          this.currentSettings = prefs.settings;
          this.lastSavedSettings = { ...this.currentSettings }; // Clone settings
        }
      });

  }

  private loadUser(token: string) {
    const url = urlJoin(this.baseUrl, this.currentUserEndpoint)

    this.getItem<ICurrentUser>(url, this.getHttpBearerHeaders(token))
      .subscribe((user: ICurrentUser) => this._currentUser$.next(user));
  }

  public getSettings(): { [key: string]: any } {
    return this.currentSettings;
  }

  public updateSetting(key: string, val: any) {
    this.currentSettings[key] = val;
  }

  public saveSettingsChanges() {
    this.save();
    this.lastSavedSettings = { ...this.currentSettings };
  }

  public cancelSettingsChanges() {
    this.currentSettings = { ...this.lastSavedSettings };
  }

  public getCurrentUser(): Observable<ICurrentUser> {
    return this._currentUser$.asObservable();
  }

  private getToken(): string | undefined {
    //return this.auth.getAccessToken();
    return this.oktaWrapper.getAccessToken();
  }


  public get emptyUser(): ICurrentUser {
    return { systemId: '0', firstName: '', lastName: '', initials: '', fullName: '', alias: '', companyName: '' };
  }

  public registerSettingsTabs(items: IUserSettingsTab[]) {
    this._settingsTabs = items;
  }

  clearLocalStorage() {
    localStorage.removeItem("currentFeatures");
    localStorage.removeItem("currentUser");
  }
  public getUserSettingsTabs(): IUserSettingsTab[] {
    return this._settingsTabs;
  }


  private save() {

    const user = this.oktaWrapper.getUser();

    if (user) {


      //this.auth.getUser()
      //  .then((user) => {

      const token = this.getToken();

      if (this.settingsObject == null) {
        this.settingsObject = {
          id: uuidv4(), userId: user.email, settings: {} // CHanged to email from id to fix an update issue. id is now returning integer
        };
      }

      if (token != undefined && this.settingsObject) { // added this.settingsObject check to prevent error when settingsObject is undefined
        this.settingsObject.settings = this.currentSettings;

        const url = urlJoin(this.baseUrl, this.settingsEndpoint)
        //Persist to service
        this.saveItem(this.settingsObject, true, url, this.getHttpBearerHeaders(token))
          .subscribe(
            (err: any) => console.log(err));
      }
      //});
    }
  }
}




